import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UploadStaffComponent } from './upload-staff.component';
import { SharedModule } from '../../../../../shared/shared.module';
import { MaterialModule } from '../../../../../shared/material.module';
import { StaffTableModule } from '../../../shared/staff-table/staff-table.module';
import { MatTableModule } from '@angular/material/table';
import { CsvFileUploadModule } from '../csv-file-upload/csv-file-upload.module';



@NgModule({
  declarations: [
    UploadStaffComponent
  ],
  exports: [
    UploadStaffComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    MaterialModule,
    StaffTableModule,
    MatTableModule,
    CsvFileUploadModule

  ]
})
export class UploadStaffModule { }
